import { HistoryProps } from "@/components/history/types";
import { FC, Fragment } from "react";
import { map, size } from "lodash";
import { Panel } from "@/components/panel";
import { HistoryItem } from "./history-item";
import styles from "./styles.scss";
import { NO_VALUE } from "@/constants";

export const History: FC<HistoryProps> = ({ history }) => {
  return (
    <Panel header="Approval history">
      <div className={styles.historyList}>
        {size(history) ? (
          map(history, (historyItem, index) => (
            <Fragment key={`history-${index}`}>
              <HistoryItem historyItem={historyItem} order={index} />
            </Fragment>
          ))
        ) : (
          <>{NO_VALUE}</>
        )}
      </div>
    </Panel>
  );
};
